import { AxiosError } from 'axios';
import { HttpStatusCode } from '../enums/HttpStatusCode';

export interface ApiErrorResponse {
  message: string;
  statusCode: number;
  error?: string;
}

export type ApiError = AxiosError<ApiErrorResponse>;

export class ApiErrorUtils {
  private static isApiError(error: unknown): error is ApiError {
    return (
      error !== null &&
      typeof error === 'object' &&
      'isAxiosError' in error &&
      error.isAxiosError === true
    );
  }

  private static getErrorStatus(error: unknown): number | null {
    if (!this.isApiError(error)) {
      return null;
    }
    return error.response?.status ?? null;
  }

  public static isForbiddenError(error: unknown): boolean {
    return this.getErrorStatus(error) === HttpStatusCode.FORBIDDEN;
  }

  public static isNotFoundError(error: unknown): boolean {
    return this.getErrorStatus(error) === HttpStatusCode.NOT_FOUND;
  }

  /** Whether a page failed because the user lacks access or it does not exist, rather than for a reason to try again */
  public static pageProblemOf(error: unknown): 'noAccess' | 'notFound' | null {
    if (this.isForbiddenError(error)) return 'noAccess';
    if (this.isNotFoundError(error)) return 'notFound';
    return null;
  }
}
